document.addEventListener("DOMContentLoaded", function () {
  const body = document.body;

  const searchContainer = document.getElementById("mobile-search-container-js");
  const searchToggle = document.querySelector(".mobile-search-icon");
  const searchInput = document.getElementById("search-input-js");
  const closeButton = document.getElementById("search-input-close-js");

  const mobileSearchResultsContainer = document.getElementById("mobile-live-search-container");
  const objectList = document.getElementById("mobile-live-search-list-js");
  const viewAllButton = document.getElementById("view-all-btn-js");

  const desktopSearchInput = document.getElementById("desktop-search-input-js");
  const deskTopObjectList = document.getElementById("desktop-live-search-list-js");

  if (
    !searchContainer ||
    !searchToggle ||
    !searchInput ||
    !closeButton ||
    !mobileSearchResultsContainer ||
    !objectList
  ) {
    return;
  }

  const hideMobileResults = () => {
    mobileSearchResultsContainer.classList.remove("live-search--active");
    mobileSearchResultsContainer.style.height = "";
    objectList.innerHTML = "";

    if (viewAllButton) {
      viewAllButton.style.display = "none";
    }
  };

  const showMobileResults = () => {
    mobileSearchResultsContainer.classList.add("live-search--active");
    mobileSearchResultsContainer.style.height = "";
  };

  window.closeSearch = function () {
    body.classList.remove("window-hidden");
    searchContainer.classList.remove("search-input--active");
    searchInput.value = "";
    hideMobileResults();
  };

  searchToggle.addEventListener("click", function () {
    window.scrollTo(0, 0);

    //body.classList.add("window-hidden");
    searchContainer.classList.add("search-input--active");

    hideMobileResults();
    searchInput.focus();
  });

  closeButton.addEventListener("click", function () {
    closeSearch();
  });

  searchInput.addEventListener("input", function (evt) {
    searchEvent(evt.target.value, "mobile");
  });

  if (desktopSearchInput && deskTopObjectList) {
    desktopSearchInput.addEventListener("input", function (evt) {
      searchEvent(evt.target.value, "desktop");
    });

    document.body.addEventListener("click", function (e) {
      if (!e.target.closest("#desktop-search-container-js")) {
        desktopSearchInput.value = "";
        deskTopObjectList.innerHTML = "";
      }
    });
  }

  const searchEvent = (eventValue, screenMode) => {
    const rawValue = eventValue.trim();

    if (!rawValue) {
      if (screenMode === "mobile") {
        hideMobileResults();
      }

      if (screenMode === "desktop" && deskTopObjectList) {
        deskTopObjectList.innerHTML = "";
      }

      return;
    }

    const searchValue = rawValue.replace(/\s/g, "+");
    const fetchQuery = `/search/suggest.json?q=${searchValue}&resources[type]=product&resources[limit]=12&resources[options][unavailable_products]=last&resources[options][fields]=title,body`;

    fetch(fetchQuery)
      .then((response) => response.json())
      .then((suggestions) => {
        const productSuggestions =
          suggestions?.resources?.results?.products || [];

        if (productSuggestions.length === 0) {
          createNoProductFound(screenMode);
          return;
        }

        const parentElement = document.createElement("div");

        productSuggestions.forEach((suggestion) => {
          const productElement = createProductElement(
            suggestion.title,
            suggestion.price,
            suggestion.image,
            suggestion.url
          );

          parentElement.appendChild(productElement);
        });

        if (screenMode === "mobile") {
          objectList.innerHTML = "";
          objectList.appendChild(parentElement);

          if (viewAllButton) {
            viewAllButton.style.display = "block";
            viewAllButton.href = `/search?q=${searchValue}`;
          }

          showMobileResults();
        }

        if (screenMode === "desktop" && deskTopObjectList) {
          deskTopObjectList.innerHTML = "";
          deskTopObjectList.appendChild(parentElement);
        }
      })
      .catch(() => {
        createNoProductFound(screenMode);
      });
  };

  const createProductElement = (title, price, imageSrc, productLink) => {
    const outerDiv = document.createElement("a");
    const imageElement = document.createElement("img");
    const innerDiv = document.createElement("div");
    const productTitle = document.createElement("p");
    const productPrice = document.createElement("p");

    outerDiv.classList.add("search--result");
    productTitle.classList.add("search--result-product-title");
    productPrice.classList.add("search--result-product-price");

    imageElement.src = imageSrc || "";
    imageElement.alt = title || "";

    outerDiv.href = productLink || "#";
    outerDiv.setAttribute("aria-label", title || "Product");

    productTitle.innerHTML = `${title.substring(0, 75)}${
      title.length > 75 ? "..." : ""
    }`;

    productPrice.innerHTML = price ? `£${price}` : "";

    outerDiv.appendChild(imageElement);
    innerDiv.appendChild(productTitle);
    innerDiv.appendChild(productPrice);
    outerDiv.appendChild(innerDiv);

    return outerDiv;
  };

  const createNoProductFound = (screenMode) => {
    const noProductDiv = document.createElement("div");
    noProductDiv.classList.add("search--result", "no-result");
    noProductDiv.innerHTML = "No products found";

    if (screenMode === "mobile") {
      objectList.innerHTML = "";
      objectList.appendChild(noProductDiv);

      if (viewAllButton) {
        viewAllButton.style.display = "none";
      }

      showMobileResults();
    }

    if (screenMode === "desktop" && deskTopObjectList) {
      deskTopObjectList.innerHTML = "";
      deskTopObjectList.appendChild(noProductDiv);
    }
  };
});